export const navigation = [
  {
    text: '使用者管理',
    path: '/auth-users',
    FunctionId: "USERLIST",
    PermissionNum: 15,
    panel: 1,
    panelTitle: '系統管理', 
  },
  {
    text: '角色維護',
    path: '/roles',
    FunctionId: "ROLE",
    PermissionNum: 15,
    panel: 1,
    panelTitle: '系統管理', 
  },
  {
    text: '系統參數維護',
    path: '/system-parameters',
    FunctionId: "PARAMETER",
    PermissionNum: 15,
    panel: 2,
    panelTitle: '參數維護', 
  },
  {
    text: '使用者操作記錄',
    path: '/log-operation',
    FunctionId: "LOGOPERATION",
    PermissionNum: 1,
    panel: 2,
    panelTitle: '參數維護', 
  },
  {
    text: '使用者閱讀記錄',
    path: '/log-read',
    FunctionId: "LOGREAD",
    PermissionNum: 1,
    panel: 2,
    panelTitle: '參數維護',
  },
  {
    text: '新問卷填寫',
    path: '/survey/new',
    FunctionId: "SURVEY_CREATE",
    PermissionNum: 1,
    panel: 3,
    panelTitle: '問卷調整', 
  },
  {
    text: '舊問卷調整',
    path: '/survey/edit',
    FunctionId: "SURVEY_EDIT", 
    PermissionNum: 1,
    panel: 3,
    panelTitle: '問卷調整'
  },
  {
    text: '問卷查詢',
    path: '/survey-management/search',
    FunctionId: "SURVEY_SEARCH", 
    PermissionNum: 1,
    panel: 4,
    panelTitle: '問卷管理', 
  },
  {
    text: '待關懷名單',
    path: '/survey-management/pending-care-list',
    FunctionId: "CARE_LIST_VIEW", 
    PermissionNum: 1,
    panel: 4,
    panelTitle: '問卷管理', 
  },
  {
    text: '名單匯入',
    path: '/survey-management/care-list-import',
    FunctionId: "CARE_LIST_IMPORT", 
    PermissionNum: 1,
    panel: 4,
    panelTitle: '問卷管理', 
  },
  {
    text: '統計報表',
    path: '/statistics-reports',
    FunctionId: "REPORTS_VIEW", 
    PermissionNum: 1,
    panel: 5,
    panelTitle: '統計報表', 
  },
]